export class EquipmentLogbookModel {
  equipmentLogbookId: number = 0;
  consecutive: number = 0;
  articleId: number = 0;
  providerId: number = 0;
  invoiceNumber: number | null = null;
  purchaseDate: Date = new Date();
  purchaseValue: number = 0;
  trademark: string | null = null;
  invoiceAttach: string | null = null;
  commercialName: string = '';
  reference: string = '';
  serie: string = '';
  yearManufacture: number | null = null;
  warrantyInitialDate: Date | null = null;
  warrantyFinalDate: Date | null = null;
  observation: string | null = null;
  equipmentType: string | null = null;
  voltage: string | null = null;
  power: string | null = null;
  amperage: string | null = null;
  capacity: string | null = null;
  engineType: string | null = null;
  engineCode: string | null = null;
  trademarkEngine: string | null = null;
  referenceEngine: string | null = null;
  serieEngine: string | null = null;
  unitId: number | null = null;
  maintenanceFrequency: number | null = null;
  tolerance: number | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}